import { useOutletContext } from "react-router-dom";
import type { ILocationDetail } from "../../customTypings/location/Location";
import type { LocationAdminConfirmKind } from "../LocationsListPage/locationAdminListActions";

export type LocationEditOutletContext = {
    locationId: string;
    locationName: string;
    locationDetail: ILocationDetail | null;
    metaDeleted: boolean;
    metaEnabled: boolean;
    setConfirmKind: (kind: LocationAdminConfirmKind | null) => void;
};

export function useLocationEditOutletContext(): LocationEditOutletContext {
    return useOutletContext<LocationEditOutletContext>();
}
